/** Default academic year: Sep 1 → Jul 30 (matches API season-style ranges). */
export function getDefaultAcademicYearRange(referenceDate = new Date()) {
  const month = referenceDate.getMonth(); // 0 = Jan
  const year = referenceDate.getFullYear();
  const startYear = month >= 8 ? year : year - 1;
  const dateFrom = `${startYear}-09-01`;
  const dateTo = `${startYear + 1}-07-30`;
  return { dateFrom, dateTo };
}

/**
 * Academic season year (Sep → Aug) for API `year` param, from an ISO date string (YYYY-MM-DD).
 */
export function getSeasonYearFromDate(dateString) {
  if (!dateString || typeof dateString !== 'string') {
    const r = getDefaultAcademicYearRange();
    return parseInt(r.dateFrom.slice(0, 4), 10);
  }
  const d = new Date(`${dateString}T12:00:00`);
  if (Number.isNaN(d.getTime())) {
    const r = getDefaultAcademicYearRange();
    return parseInt(r.dateFrom.slice(0, 4), 10);
  }
  const m = d.getMonth();
  const y = d.getFullYear();
  return m >= 8 ? y : y - 1;
}
